import { MutationTree } from "vuex";
import { AuthState, User } from "./state";

export const mutations: MutationTree<AuthState> = {
  SET_USER(state, user: User) {
    state.user = user;
    localStorage.setItem("user", JSON.stringify(user));
  },
  SET_TOKEN(state, token: string) {
    state.token = token;
    state.isAuthenticated = true;
    localStorage.setItem("token", token);
  },
  LOGOUT(state) {
    state.user = null;
    state.token = null;
    state.isAuthenticated = false;
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  },
};
